import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/** True below the `sm` breakpoint (phones): the shared "hide low-priority
 *  table columns" signal. One home so the three tables never drift. */
export function useCompact(): boolean {
  return useMediaQuery(useTheme().breakpoints.down('sm'));
}

export default useCompact;
